import React from 'react';
import { cn } from '@/lib/utils';
import { getKlaroIconPath } from '@/config/klaroIcons';

const IMAGE_SIZES = {
  badge: 'h-4 w-4',
  action: 'h-6 w-6',
  sidebar: 'h-7 w-7',
  sidebarWide: 'h-6 w-9',
  page: 'h-10 w-10',
  card: 'h-[94px] w-[120px] sm:h-[100px] sm:w-[134px] xl:h-[106px] xl:w-[144px]',
  compactCard: 'h-10 w-12',
};

const VECTOR_SIZES = {
  badge: 'h-4 w-4',
  action: 'h-5 w-5',
  sidebar: 'h-[22px] w-[22px]',
  sidebarWide: 'h-[22px] w-9',
  page: 'h-6 w-6',
  card: 'h-7 w-7',
  compactCard: 'h-5 w-5',
};

export default function AppIcon({ icon, size = 'action', className, alt = '', ...props }) {
  if (!icon) return null;

  if (typeof icon === 'string') {
    const src = getKlaroIconPath(icon) || icon;
    return (
      <img
        src={src}
        alt={alt}
        aria-hidden={alt ? undefined : 'true'}
        className={cn('shrink-0 object-contain', IMAGE_SIZES[size] || IMAGE_SIZES.action, className)}
        draggable="false"
        {...props}
      />
    );
  }

  const Icon = icon;
  return <Icon className={cn(VECTOR_SIZES[size] || VECTOR_SIZES.action, className)} stroke={1.75} aria-hidden="true" {...props} />;
}
